/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { CountryVoModel } from '@well/common-libs/country-management/domain-model';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';

@Injectable({
  providedIn: 'root'
})
export class CountryVoResourceService extends SelectableResourceService<CountryVoModel> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('countryUrl')}/vos`,
      CountryVoModel
    );
  }

}
